import React from 'react';
import { T } from '../constants';
import { mlColor, systemLabel } from '../helpers';

// TIER strategies put the verdict in `action_label`, not `action`. Prefer it.
const verdict = d => d.action_label || d.action;

export default function Ticker({ decisions, feedColor, perSystem, showSystem }) {
  const trades   = decisions.filter(d => verdict(d) === 'TRADE').length;
  const observes = decisions.filter(d => verdict(d) === 'OBSERVE').length;
  const avgML   = decisions.length
    ? (decisions.reduce((s, d) => s + (parseFloat(d.ml_score) || 0), 0) / decisions.length).toFixed(1)
    : null;

  const items = [
    { label: 'DECISIONS', value: decisions.length,  color: feedColor },
    { label: 'TRADES',    value: trades,             color: T.bull },
    ...(observes > 0 ? [{ label: 'OBSERVE', value: observes, color: T.purple }] : []),
    { label: 'AVG ML',    value: avgML ?? '—',       color: avgML ? mlColor(avgML) : T.textMuted },
  ];

  if (showSystem && perSystem) {
    Object.entries(perSystem).forEach(([sid, info]) => {
      items.push({ label: systemLabel(sid), value: info.count, color: T.textDim });
    });
  }

  return (
    <div className="ticker">
      {items.map((item, i) => (
        <div key={i} className="ticker-item">
          <span className="ticker-label">{item.label}</span>
          <span className="ticker-value" style={{ color: item.color }}>{item.value}</span>
        </div>
      ))}
    </div>
  );
}
